
import Vue from 'vue'

export default Vue.extend({
  name: 'HomePage',
  data() {
    return {
      links: [
        { text: 'Project Code', to: { name: 'EvaluationList' }, internal: true },
        { text: 'Survey Type', to: { name: 'SurveyTypeList' }, internal: true },
        { text: 'Funding Type', to: { name: 'FundingTypeList' }, internal: true },
        { text: 'Penalty Assessment', to: { name: 'PenaltyAssessmentList' }, internal: true },
        { text: 'Survey Funding Percent', to: { name: 'SurveyFundingPercentList' }, internal: true },
        {
          text: 'HRD Reports (Tableau)',
          to: 'https://tableau.internal.web.health.state.mn.us/#/site/production/views/HRDReportsTableofContents/Reports?:iid=1',
          internal: false
        }
      ]
    }
  },
  methods: {
    navigate(link: { to: any; internal: boolean }) {
      if (link.internal) {
        this.$router.push(link.to)
      } else {
        window.open(link.to, '_blank', 'noopener')
      }
    }
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$keycloak && this.$keycloak.authenticated
    }
  }

})
